import { BlogPostBrowser } from "~/components/blog/BlogPostBrowser";
import { MarginLayout } from "~/components/layouts/MarginLayout";
import SectionStrip from "~/components/SectionStrip";
import { BG } from "~/components/theme/colors";
import {
  BLOG_ARCHIVE_TITLE,
  type BlogArchivePageData,
} from "~/lib/blogArchive";

export const BlogArchiveContent: React.FC<BlogArchivePageData> = ({
  allPosts,
  pagePosts,
  currentPage,
  totalPages,
}) => {
  return (
    <>
      <SectionStrip
        title={BLOG_ARCHIVE_TITLE}
        bgClassName={BG.primary}
        paddingClassName="px-4 py-12 sm:py-16 lg:px-6"
        titleClassName="bg-transparent font-semibold h2 text-white"
      />
      <MarginLayout className="mx-auto max-w-5xl py-12">
        {allPosts.length === 0 ? (
          <p className="text-center text-gray-500">Brak artykułów.</p>
        ) : (
          <BlogPostBrowser
            allPosts={allPosts}
            pagePosts={pagePosts}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        )}
      </MarginLayout>
    </>
  );
};
